import React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Box, Image, Text } from 'wix-style-react';
import { getClientImageURL } from '../../..';
export var AppIntro = composer()
    .withExperiments()
    .compose(function (_a) {
    var app = _a.app, appEmbeddedScriptAppsStatus = _a.appEmbeddedScriptAppsStatus, experiments = _a.experiments;
    var appName = app.webSolutionBase.name;
    var appIconSrc = app.webSolutionBase.icon;
    return (React.createElement(Box, { align: "center", verticalAlign: "middle" },
        React.createElement("span", { style: {
                height: '36px',
                width: '36px',
                borderRadius: '6px',
                border: '1px solid rgb(240, 244, 247)',
                boxSizing: 'border-box',
            } },
            React.createElement(Image, { width: 36, height: 36, src: getClientImageURL(appIconSrc, {
                    originalWidth: 1000,
                    originalHeight: 1000,
                    toWidth: 36,
                    toHeight: 36,
                }) })),
        React.createElement(Box, { marginLeft: "12px", direction: "horizontal", dataHook: appName, align: "space-between" },
            React.createElement(Text, { size: "medium", weight: "bold", skin: "standard" }, appName))));
});
//# sourceMappingURL=app-intro.js.map